export default "__VITE_ASSET__CyhHIIZc__"